import { createSelector } from "reselect";

import { EMPTY_ARRAY, EMPTY_OBJECT } from "lib";

import { getEmails, getReportJobs } from "../root";
import {
  BusinessAggridDataPacket,
  selectBusinessesAggridDataById,
} from "./businesses";

interface ReportJobWithEmails extends ReportJob {
  emails: Email[];
}

export type ReportJobAggridData = Omit<
  Partial<BusinessAggridDataPacket>,
  "business"
> & {
  reportJob: ReportJobWithEmails;
  business: BusinessAggridDataPacket["business"] | object;
};

export const selectReportJobAggridData = createSelector(
  [getReportJobs, getEmails, selectBusinessesAggridDataById],
  (
    reportJobByIdLookup: Record<string, ReportJob>,
    emailByIdLookup: Record<string, Email>,
    businessesAggridDataById: Record<string, BusinessAggridDataPacket>,
  ): ReportJobAggridData[] => {
    const data: ReportJobAggridData[] = [];
    for (const reportJob of Object.values(reportJobByIdLookup)) {
      // References the FIRST business in the document.
      const businessAggridData = reportJob.businessIds
        ?.map(id => businessesAggridDataById[id])
        .filter(Boolean)?.[0];

      data.push({
        ...businessAggridData,
        reportJob: {
          ...reportJob,
          emails:
            reportJob.emailIds?.map(id => emailByIdLookup[id]) || EMPTY_ARRAY,
        },
        business: businessAggridData?.business || EMPTY_OBJECT,
      });
    }
    return data;
  },
);
